export default {
  state: {
    loading: true,
    mask: false,
    feedbackVisible: true,
    currentPageInfoComponent:''
  },
  getters: {
    currentPageInfoComponent: state => {
      return state.currentPageInfoComponent
    },
  },
  mutations: {
    showLoad (state) {
      state.loading = true
    },
    hideLoad (state) {
      state.loading = false
    },
    showMask (state) {
      state.mask = true
    },
    hideMask (state) {
      state.mask = false
    },
    showFeedback (state) {
      state.feedbackVisible = true
    },
    hideFeedback (state) {
      state.feedbackVisible = false
    },
    setCurrentPageInfoComponent (state,info) {
      state.currentPageInfoComponent = info
    },
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/base.js